import React from 'react';

import './RainEffect.scss';

function RainEffect() {
  return (
    <div className="rain-container">
      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <div className="rain">
        <div className="drop"></div>
        <div className="particles">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(RainEffect);
